export default function ServicesSection() {
  const services = [
    {
      number: '01',
      title: 'UI/UXデザイン',
      description: 'ユーザー中心設計の原則に基づき、直感的で使いやすいインターフェースを設計します。リサーチからプロトタイピング、ユーザビリティテストまで、一貫したプロセスで最適な体験を創出します。',
      includes: [
        'ユーザーリサーチ & ペルソナ設計',
        'ワイヤーフレーム & プロトタイプ',
        'ビジュアルデザイン & モックアップ',
        'ユーザビリティテスト & 改善提案'
      ]
    },
    {
      number: '02',
      title: 'ブランディング',
      description: 'ブランドの本質を見極め、一貫性のあるビジュアルアイデンティティを構築します。ロゴデザインからブランドガイドライン、各種クリエイティブまで、トータルでサポートします。',
      includes: [
        'ブランド戦略 & ポジショニング',
        'ロゴ & ビジュアルアイデンティティ',
        'ブランドガイドライン作成',
        '各種クリエイティブ制作'
      ]
    },
    {
      number: '03',
      title: 'Webデザイン',
      description: 'レスポンシブ対応はもちろん、SEOやアクセシビリティにも配慮した、ビジネス成果につながるWebサイトを設計・制作します。CMSの導入支援も行います。',
      includes: [
        'コーポレートサイト設計',
        'ECサイト & ランディングページ',
        'レスポンシブデザイン',
        'CMS導入 & 運用サポート'
      ]
    },
    {
      number: '04',
      title: 'モバイルアプリデザイン',
      description: 'iOS・Android両プラットフォームのガイドラインに準拠しつつ、独自性のあるアプリ体験を設計します。プロトタイプを用いた検証を重視し、リリース後の改善もサポートします。',
      includes: [
        'iOS & Androidアプリデザイン',
        'インタラクションデザイン',
        'プロトタイプ作成 & 検証',
        'アプリアイコン & ストア素材'
      ]
    },
    {
      number: '05',
      title: 'デザインシステム構築',
      description: '組織全体でデザインの一貫性を保つため、再利用可能なコンポーネントライブラリとガイドラインを構築します。開発チームとの協業もスムーズに進められます。',
      includes: [
        'コンポーネントライブラリ設計',
        'デザイントークン定義',
        'ドキュメント & ガイドライン',
        '開発チームとの連携サポート'
      ]
    },
    {
      number: '06',
      title: 'クリエイティブディレクション',
      description: 'プロジェクト全体のクリエイティブ品質を統括し、戦略立案から実制作、品質管理までをリードします。チームマネジメントやクライアント折衝も担当します。',
      includes: [
        'クリエイティブ戦略立案',
        'アートディレクション',
        'チームマネジメント',
        'クライアントプレゼンテーション'
      ]
    }
  ];

  return (
    <section id="services" className="relative py-24 lg:py-32 bg-[#000000]">
      <div className="absolute right-0 top-1/4 w-1/2 h-1/2 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hexagons" width="20" height="17.32" patternUnits="userSpaceOnUse">
              <path d="M10 0 L15 8.66 L10 17.32 L5 8.66 Z" fill="none" stroke="#c9a96e" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#hexagons)" />
        </svg>
      </div>

      <div className="relative z-10 px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-7xl font-thin text-[#f5f5f0] mb-4">Services</h2>
          <div className="w-32 h-px bg-[#c9a96e] mx-auto mb-4"></div>
          <p className="text-sm text-[#d4c5b9]/70 tracking-wider">専門領域と提供価値</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-x-8 lg:gap-y-10">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-[#252525] rounded-3xl p-8 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#c9a96e]/10 transition-all duration-500 cursor-pointer ${
                index >= 3 ? 'lg:translate-y-5' : ''
              }`}
            >
              <div className="relative mb-6">
                <div className="text-[120px] font-black text-[#f5f5f0]/10 leading-none">
                  {service.number}
                </div>
                <h3 className="absolute top-8 left-0 text-2xl lg:text-3xl font-semibold text-[#d4c5b9]">
                  {service.title}
                </h3>
              </div>

              <div className="w-full h-px bg-[#c9a96e]/20 mb-6"></div>

              <p className="text-sm leading-relaxed text-[#f5f5f0]/70 mb-6">
                {service.description}
              </p>

              <div className="space-y-3 mb-6">
                <div className="text-xs text-[#c9a96e] font-medium tracking-wider">含まれる内容</div>
                {service.includes.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-2">
                    <i className="ri-check-line text-[#c9a96e] mt-0.5 flex-shrink-0"></i>
                    <span className="text-xs text-[#f5f5f0]/60">{item}</span>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="inline-flex items-center gap-2 text-xs text-[#d4c5b9] hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer group-hover:gap-3"
              >
                <span className="border-b border-current">詳細を見る</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}